import React from 'react';
// import '../Summary-Swap.css';
import Helmet from "react-helmet/es/Helmet";
import NewBookingDetails from './New-BookingDetails';
import ExploreMoreLinks from './ExploreMoreLinks';

class SummarySwap extends React.Component {

    constructor(props) {
        super(props);
        this.paymentFormRef = React.createRef();
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;

        this.state = {
        	guestList: '',
            showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            updateBooking: this.props.booking,
            cruiselines : [],
            charges: {
                totalWithOutInsurance: this.booking.totalWithOutInsurance,
                insuranceTotal: this.booking.insuranceTotal,
                paymentsReceived: this.booking.paymentsReceived,
                pendingPaymentTotal: this.booking.pendingPaymentTotal,
                remainingBalanceIncludingInsurance: this.booking.remainingBalanceIncludingInsurance,
                remainingBalanceExcludingInsurance: this.booking.remainingBalanceExcludingInsurance,
                nextPaymentDueDate: this.booking.nextPaymentDueDate,
                finalPaymentDate: this.booking.finalPaymentDate,
                includeInsurance: this.booking.remainingBalanceIncludingInsurance !== this.booking.remainingBalanceExcludingInsurance,
                currentAmount: 0
            },
			showPhoneNumber: this.props.booking.bookingOverview.luxuryBooking ? this.props.siteConfigData.store.luxuryPhone : this.props.siteConfigData.cruisePhone,
			updateVanityNumber: null,
			isSiteVanity: false
        }
        this.daysBeforePaymentDueDate = 0;
		this.siteZendeskID = this.getSitePropertyValue("ZENDESK_ID");

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else {
				console.log("off");    
			}
       
        } catch (error) {
            //swallow error
        }
    }

	replaceIfIsLuxuryBooking = () => {
		const elementsWithNums = document.querySelectorAll('.js-change-phone-number')

		let updatedCruisePhone; 
		updatedCruisePhone = this.state.updateVanityNumber;
		for (var i = 0; i < elementsWithNums.length; i++) {
		
			if (this.state.isSiteVanity) {
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[0], this.state.showPhoneNumber)
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[1], this.state.showPhoneNumber)
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[2], this.state.showPhoneNumber)
				
			} else {
				updatedCruisePhone = this.props.siteConfigData.cruisePhone;
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone, this.state.showPhoneNumber)
			}
		}

		if (this.props.siteConfigData.store.storeCode === "CRZNW") {
			elementsWithNums[0].children[0].innerHTML = elementsWithNums[0].children[0].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
		} 
		
		if (this.props.siteConfigData.store.storeCode === "RIWEB") {
			elementsWithNums[0].children[0].innerHTML = elementsWithNums[0].children[0].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
			elementsWithNums[1].children[2].innerHTML = elementsWithNums[1].children[2].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
		}
	}

	checkIfSiteVanity = () => {
		if (this.props.siteConfigData.store.storeCode === "CRZNW" || this.props.siteConfigData.store.storeCode === "CNCLW") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8002784737"),
				isSiteVanity: true
			})
		} else if (this.props.siteConfigData.store.storeCode === "VOWEB") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8008253633"),
				isSiteVanity: true
			})
		} else if (this.props.siteConfigData.store.storeCode === "RIWEB") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8777242628"),
				isSiteVanity: true
			})
		}
	}

	setupNumbersWithVanity = (phoneNumber) => {

		const updateNumWithOneHyphen = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3);
		const updateNumWithTwoHyphen = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3, 6) + "-" + phoneNumber.slice(6);

		const formattedPhoneNumberWith1 = '1-' + updateNumWithTwoHyphen;

	
		if (this.props.booking.bookingOverview.luxuryBooking === false) {
			this.setState({
				showPhoneNumber: formattedPhoneNumberWith1
			})
		}
		return [formattedPhoneNumberWith1, updateNumWithOneHyphen, updateNumWithTwoHyphen];

	}
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    
    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
    	 document.getElementById("ajaxLoadText").innerHTML = "loading";
    	 document.getElementById("ajaxShim").style.display = "block";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
    	 document.getElementById("ajaxSpinner").style.display = "block";
     }	
     
     ajaxSpinnerHide = () => {
    	 document.getElementById("ajaxSpinner").style.display = "none";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
    	 document.getElementById("ajaxShim").style.display = "none";
     }

    setConfirmationNumberStorage = () => {
    	localStorage.setItem("confirmationNumber", this.state.updateBooking.bookingNumber);
    	return '';
    }

    
    componentWillMount = () => {
    	this.ajaxSpinnerShow();
		this.setConfirmationNumberStorage();
    	console.debug('getting booking in summary...');
        let url = '/wthrest/customer-self-service/getBooking.rs';
        let payload = {
            "bookingNumber": this.props.booking.bookingNumber,
            "hash": this.props.hash
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => {
        	this.ajaxSpinnerHide();
        	this.setState({updateBooking: jsonBookingResponse});
        	this.setState({booking: jsonBookingResponse});
        	localStorage.setItem('previousPayments', this.state.updateBooking.bookingSummary.charges.paymentsToDate);
			
			this.checkIfSiteVanity();
			if (this.props.booking.bookingOverview.luxuryBooking) {
				this.replaceIfIsLuxuryBooking();
			}
        	return jsonBookingResponse;
        	
        	
        }).catch(error => {
        	this.ajaxSpinnerHide();
        	console.log("get booking failed");
            //TODO set error
        	return null;
        });

    }

	getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    
    componentDidMount() {
        this.checkCruiseline();
        }
        
    componentDidUpdate(prevProps, prevState) {
    if (
        this.booking !== prevProps.booking ||
        this.siteConfigData !== prevProps.siteConfigData
        ) {
            this.checkCruiseline();
            }
            }
                            
   checkCruiseline() {
    const bookingCruiseData = this.booking?.bookingOverview?.cruise;
    const siteProps = this.siteConfigData?.siteProperties || [];  
    
    if (!bookingCruiseData || !bookingCruiseData.cruiseLineId) {    
        if (this.state.cruiselines.length > 0) {
            this.setState({ cruiselines: [] });
            }
            return;
          }

   const bookingCruiseId = bookingCruiseData.cruiseLineId;

   const isMatched = siteProps.some((prop) => {
    if (prop.propertyName === "BCSS_API_CRUISELINE_IDS") {
     const values = prop.propertyValue?.split(',').map(id => id.trim());
     return values.includes(bookingCruiseId);
      }
     return false;
    });

  const apiCruiseName =
    isMatched && bookingCruiseData.cruiseLineName
      ? [bookingCruiseData.cruiseLineName]
      : [];
  const current = this.state.cruiselines;
  const hasChanged =
    apiCruiseName.length !== current.length ||
    apiCruiseName.some((name, i) => name !== current[i]);

  if (hasChanged) {
    this.setState({ cruiselines: apiCruiseName });
    }
   }

    
    
     render = () => {
		const apiCruisLines = this.state.cruiselines;			      		
        return (
            <div className="wth3-summaryContainer" id="cssSummaryContainer" tabindex="-1">
                <Helmet>
                    <title>Customer Self Service / Summary</title>
                </Helmet> 
				
	            <div id="message" class="wth2-errorMessage wth2-errorMessageHeader" style={{ display: 'none'}}></div>
	            <div id="messageInvoice" class="wth2-sucessMessage" style={{ display: 'none'}}>
					<div class="wth2-sucessMessageCont">
						<div class="wth2-sucessMessageHeader" id="messageInvoiceCont"></div>
						<div id="messageInvoiceSub"></div>
					</div>
				</div>
	            <div id="messageInvoiceFail" class="wth2-errorMessage wth2-errorMessageHeader" style={{ display: 'none'}}><div class="wth2-sucessMessageCont wth2-sucessMessageHeader" id="messageInvoiceFailCont"></div></div>

                {/***********************  Booking Summary ************************/}
                <NewBookingDetails {...this.props} {...this.state} apiCruisLines={apiCruisLines} getSitePropertyValue={this.getSitePropertyValue} getStoreAttValue={this.getStoreAttValue} />
                    
				{/***********************  Explore More Links  ************************/}
                <ExploreMoreLinks {...this.props} {...this.state} apiCruisLines={apiCruisLines} ajaxSpinnerShow={this.ajaxSpinnerShow} ajaxSpinnerHide={this.ajaxSpinnerHide} getSitePropertyValue={this.getSitePropertyValue} siteZendeskID={this.siteZendeskID} getStoreAttValue={this.getStoreAttValue}  />
                	
            </div>
        );
    }
   
}

export default SummarySwap;
